import la from './la';
import si from './si';

// Each peer program owns its student application: its steps, questions,
// summary and checks. Adding a program is a new definition here.
export const PROGRAM_DEFINITIONS = { la, si };

export const getProgramDefinition = (key) => PROGRAM_DEFINITIONS[key] || null;

export default PROGRAM_DEFINITIONS;
